import { render, staticRenderFns } from "./supervisor.vue?vue&type=template&id=ce28af3a&"
import script from "./supervisor.vue?vue&type=script&lang=ts&"
export * from "./supervisor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports